/* global Cookies, lightbox */
/* eslint-env jquery, cookie */

'use strict';

/*
 * ---------------------------------------------------------------
 * Non jQuery
 * ---------------------------------------------------------------
 */

/*
 * Initialize Fancybox image zoom and bind it to custom zoom button
 */
Fancybox.bind('.gallery__item, .content-gallery-item, .single-gallery-item, .guest-post-zoom', {
	Thumbs: {
		showOnStart: true,
	}
});

jQuery( function( $ ) {

	$( window ).on( 'scroll', function () {

		if ( $( window ).scrollTop() > 270 ) {
			$( '#navigation').addClass( 'nav-primary--sticky' );
			$( '#stickyCTA' ).addClass( 'sticky-cta--visible' );
		} else {
			$( '#navigation').removeClass( 'nav-primary--sticky' );
			$( '#stickyCTA' ).removeClass( 'sticky-cta--visible' );
		}
	} );

	/*
	 * Scroll Down
	 */
	$( document ).on( 'click', '#scrollDown', function( event ) {
		event.preventDefault();
		const pos = ( $(this).offset().top + 100 );

		$( 'html, body' ).animate( { scrollTop: pos }, 800 );
	} );

	/*
	 * Main slider
	*/
	$( '#slider' ).slick( {
		mobileFirst: true,
		arrows: true,
		infinite: true,
		speed: 1200,
		slidesToShow: 1,
		autoplay: false,
		autoplaySpeed: 6000,
		pauseOnHover: false,
		variableWidth: false,
		responsive: [
			{
			  breakpoint: 576,
			  settings: {
				variableWidth: true,
			  }
			},
		  ]
	} );

	$( '#reviewSlider' ).slick( {
		arrows: false,
		dots: true,
		infinite: true,
		speed: 1200,
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 6000,
		pauseOnHover: false,
	} );

	// Show side menu
	$( document ).on( 'click', '#showMobileMenu', function( event ) {
		event.preventDefault();
		$( '#mobileMenu' ).addClass( 'nav-mobile--visible' );
		$( 'body' ).addClass( 'modal-open' );
	} );

	// Hide side menu
	$( document ).on( 'click', '#hideMobileMenu', function( event ) {
		event.preventDefault();
		$( '#mobileMenu' ).removeClass( 'nav-mobile--visible' );
		$( 'body' ).removeClass( 'modal-open' );

	} );

	$( '.page-before-after__slider' ).beforeAfter({
		movable: true,
		clickMove: true,
		position: 50,
		separatorColor: '#fafafa',
		bulletColor: '#fafafa',
		onMoveStart: function(e) {
			console.log(event.target);
		},
		onMoving: function() {
			console.log(event.target);
		},
		onMoveEnd: function() {
			console.log(event.target);
		},
	});

	$( document ).on( 'click', '.menu-item-has-children > a > .menu-toggler', function( e ) {
		e.preventDefault();
		const navItem = $( this ).parent().parent();

		if ( navItem.hasClass( 'menu-item-visible' ) ) {
			navItem.children( '.menu-mobile-sub' ).slideToggle();
			navItem.removeClass( 'menu-item-visible' );

		} else {
			navItem.children( '.menu-mobile-sub' ).slideToggle();
			navItem.addClass( 'menu-item-visible' );

		}
	} );
} );
